/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ExceptionReviewListing = {
    uuid: string;
    exception: string;
    review_date?: string;
    /**
     * Reviewer of the exception.
     */
    reviewer: string;
    status?: ExceptionReviewListing.status;
    notes?: string | null;
}

export namespace ExceptionReviewListing {

    export enum status {
        UNKNOWN = 'unknown',
        APPROVED = 'approved',
        DENIED = 'denied',
        TENTATIVE = 'tentative',
    }


}
